// In the following line, you should include the prefixes of implementations you want to test.
import {isSentry} from './lib';

const indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.OIndexedDB || window.msIndexedDB;
const databaseName = 'recordings';
const dbVersion = 1.0;
  
const createObjectStore = (database) => {
  // Create an objectStore
  database.createObjectStore(databaseName);
}

const getTransaction = (db, permission = "readwrite") => {
  try {
    const transaction = db.transaction([databaseName], permission);

    return transaction;
  } catch (err) {
    isSentry(err)
    return false;
  }
}

export default function(blob, randomKey, roomName, callback) {
  if (!blob) {
    return callback({
      success: false,
      reason: "File could not ne recorded because of invalid file format, please try again."
    });
  }
  // Let us open our database
  const DBOpenRequest = indexedDB.open(databaseName, dbVersion);
  let db;
  
  const putRecordingInDb = async () => {
    
    // open a transaction to the db
    
    var tempVideoEl = document.createElement('video');
    tempVideoEl.addEventListener('loadedmetadata', function() {
      const transaction = getTransaction(db);
      // duration is now available here -- store it somewhere as you like
      const fileItem = {
        file: blob,
        date: new Date(),
        roomName,
        duration: tempVideoEl.duration,
      }
      // put blob in the database
      transaction.objectStore(databaseName).put(fileItem, randomKey);
    
      // retrieve the file that was just stored
      transaction.objectStore(databaseName).get('image').onsuccess = (event) => {
        const file = event.target.result;
      }
    });
    
    tempVideoEl.src = window.URL.createObjectURL(blob);
  }
  
  DBOpenRequest.onerror = function(event) {
    isSentry(`Error Loading Database while trying to save file: ${event}`);
  };
  
  DBOpenRequest.onsuccess = function() {
    callback({
      success: true,
    });
    // store the result of opening the database in the db variable. This is used a lot below
    db = DBOpenRequest.result;
    db.onerror = function (event) {
      isSentry(`Error Loading Database while trying to save file: ${event}`);
    };
  
    putRecordingInDb();
  };
  
  // For future use. Currently only in latest Firefox versions
  DBOpenRequest.onupgradeneeded = function (event) {
    createObjectStore(event.target.result);
  };
}


export function getFileBlob(key, callback) {

  // Let us open our database
  const DBOpenRequest = indexedDB.open(databaseName, dbVersion);
  let db;
  
  
  
  DBOpenRequest.onerror = function(event) {
    isSentry(`Error Loading Database while trying to get a file: ${event}`);
  };
  
  DBOpenRequest.onsuccess = function() {
    // store the result of opening the database in the db variable. This is used a lot below
    db = DBOpenRequest.result;
    db.onerror = function (event) {
      isSentry(`Error creating/accessing IndexedDB database while trying to get a file: ${event}`);
    };
    // open a transaction to the db
    const transaction = getTransaction(db);
    if (!transaction) return callback(false);
    // retrieve the file by key
    transaction.objectStore(databaseName).get(key).onsuccess = (event) => {
      const file = event.target.result;
      callback(file.file);
    }
  };

  // For future use. Currently only in latest Firefox versions
  DBOpenRequest.onupgradeneeded = function (event) {
    createObjectStore(event.target.result);
  };
}

export function showAllRecordings(callback) {
  // Let us open our database
  const DBOpenRequest = indexedDB.open(databaseName, dbVersion);
  let db;
  DBOpenRequest.onerror = function(event) {
    isSentry(`Error Loading Database while trying to get all recordings: ${event}`);
  };
  
  DBOpenRequest.onsuccess = function(event) {
    // store the result of opening the database in the db variable. This is used a lot below
    db = DBOpenRequest.result;
    db.onerror = function (event) {
      isSentry(`Error creating/accessing IndexedDB database while trying to get all recordings: ${event}`);
    };
    const transaction = getTransaction(db, 'readwrite');
    if (!transaction) return callback([]);
    const store = transaction.objectStore(databaseName);
    var cursorRequest = store.openCursor();
    const items = [];

    cursorRequest.onerror = function(error) {
      isSentry(`Error while parsing the recordings db: ${error}`)
    };

    // cursorRequest.objectStore(databaseName).getAll();
    cursorRequest.onsuccess = (event) => {
      const cursor = event.target.result;

      if (cursor && cursor.value.file && cursor.value.file instanceof Blob) {
        const fileItem = {
          id: cursor.key,
          data: cursor.value,
          url: window.URL.createObjectURL(cursor.value.file),
        }
        items.push(fileItem);
        cursor.continue();
      }
    }
    transaction.oncomplete = function(evt) {
      callback(items);
    };
  };
  
  // For future use. Currently only in latest Firefox versions
  DBOpenRequest.onupgradeneeded = function (event) {
    createObjectStore(event.target.result);
  };
}

export function deleteFile(key, callback) {
  // Let us open our database
  const DBOpenRequest = indexedDB.open(databaseName, dbVersion);
  let db;

  DBOpenRequest.onerror = function(event) {
    isSentry(`Error Loading Database while trying to delete a file: ${event}`);
  };
  
  DBOpenRequest.onsuccess = function(event) {
    // store the result of opening the database in the db variable. This is used a lot below
    db = DBOpenRequest.result;
    db.onerror = function (event) {
      isSentry("Error creating/accessing IndexedDB database");
    };
    const transaction = getTransaction(db, 'readwrite');
    if (!transaction) return callback([]);
    const store = transaction.objectStore(databaseName);

    // store the result of opening the database in the db variable. This is used a lot below
    db = DBOpenRequest.result;
    db.onerror = function (event) {
      isSentry(`Error creating/accessing IndexedDB database while trying to delete a file: ${event}`);
    };

    // retrieve the file that was just stored
    if (key === 'all') {
      return store.clear().onsuccess = () => {
        showAllRecordings(recordings => callback(recordings));
      }
    }
    store.delete(key).onsuccess = () => {
      showAllRecordings(recordings => callback(recordings));
    }
  };
  
  // For future use. Currently only in latest Firefox versions
  DBOpenRequest.onupgradeneeded = function (event) {
    createObjectStore(event.target.result);
  };
}





// WEBPACK FOOTER //
// ./src/lib/IndexedDB.js